// extracted by mini-css-extract-plugin
export default {"root":"SummaryWidgetGroup_root__HHRlD"};